import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { useDispatch } from '../../../Flux/index.ts'
import { orderWizardActions as wizard } from '../../../Flux/Slice/OrderWizard/OrderWizardSlice.ts'
import type { DropNotice } from '../../../Services/OrderWizard/dropNotice.ts'
import { dropNoticeText } from '../../../Services/OrderWizard/dropNotice.ts'

export const DropNoticeLine = ({ notice }: { notice: DropNotice }) => {
  const dispatch = useDispatch()
  const dismiss = () => dispatch(wizard.dropNoticeDismissed({ id: notice.id }))
  return (
    <span className="inline-flex flex-wrap items-center gap-x-1.5 text-xs text-slate-600" data-testid="wizard-drop-notice">
      <CheckCircleIcon className="h-3.5 w-3.5 text-slate-400" aria-hidden />
      <span data-testid="wizard-drop-notice-text">{dropNoticeText(notice)}</span>
      <button type="button" className="btn btn-ghost btn-xs btn-square" aria-label="Dismiss" onClick={dismiss}>
        <XMarkIcon className="h-3 w-3" />
      </button>
    </span>
  )
}
